import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { LessorRepTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-lessor-rep-type-container',
  templateUrl: './lessor-rep-type-container.component.html',
  styleUrls: ['./lessor-rep-type-container.component.scss'],
})
export class LessorRepTypeContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  lessorreptypes$: Observable<LessorRepTypeDto[]>;
  loading: boolean;
  isLoadingLessorRepType$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingLessorRepType$ = this.gatwayFacade.isLoadingGateway(
      'LessorRepType'
    );
    this.lessorreptypes$ = this.gatwayFacade.loadGateway('LessorRepType');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLessorRepType(deletedValue: any) {
    this.gatwayFacade.remove('LessorRepType', deletedValue);
  }

  // this method control both the create and update

  onSubmitLessorRepType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.LessorRepTypes;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllLessorRepType = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllLessorRepType.push(pullData[i]);
      }
    }

    // check if the addAllLessorRepType array is not empty, then dispatch the data to the store
    if (addAllLessorRepType.length > 0) {
      this.gatwayFacade.add('LessorRepType', addAllLessorRepType);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('LessorRepType', allUpdates, ['id']);
    }
  }
}
